export const companyStats = [
  { value: '2018', label: '成立年份' },
  { value: '500+', label: '服务企业' },
  { value: '120+', label: '技术团队' },
  { value: '30+', label: '城市覆盖' },
];

export const milestones = [
  {
    year: '2018',
    title: 'Firmai 成立',
    description: '在北京成立，专注企业能源管理数字化领域，创始团队来自清华、北大等顶尖高校。',
    highlight: false,
  },
  {
    year: '2019',
    title: '首款产品发布',
    description: '发布 Firmai 能源监测平台 1.0，首批签约 20 家制造业客户，实现能耗数据实时可视化。',
    highlight: false,
  },
  {
    year: '2020',
    title: 'AI 引擎上线',
    description: '自主研发 AI 能耗预测引擎，预测准确率达 92%，帮助客户平均节能 15%。获得 A 轮融资。',
    highlight: true,
  },
  {
    year: '2021',
    title: '碳排放模块发布',
    description: '推出碳排放追踪与核算功能，助力企业应对双碳目标。客户突破 200 家，覆盖 15 个城市。',
    highlight: false,
  },
  {
    year: '2022',
    title: '企业工具集成',
    description: '完成钉钉、飞书、企业微信等主流办公平台集成，实现能源报告自动推送。获得 B 轮融资。',
    highlight: false,
  },
  {
    year: '2023',
    title: '合规服务上线',
    description: '推出绿色工厂申报、CCER 碳汇开发、CBAM 碳边境调节等合规服务，成为行业首家全链条服务商。',
    highlight: true,
  },
  {
    year: '2024',
    title: '国际化拓展',
    description: '服务客户突破 500 家，覆盖 30+ 城市。启动海外市场布局，为出口企业提供 CBAM 合规支持。',
    highlight: false,
  },
  {
    year: '2025',
    title: '大模型赋能',
    description: '接入大语言模型，推出 AI 能源顾问功能，实现自然语言交互式能耗分析与优化建议。',
    highlight: true,
  },
];

export const teamMembers = [
  {
    name: '张小奎',
    title: '创始人 & CEO',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20tech%20CEO%20portrait%20headshot%20wearing%20dark%20suit%20confident%20smile%20clean%20studio%20background%20corporate%20photography%20high%20quality&width=200&height=200&seq=team1&orientation=squarish',
    bio: '荷兰屯特大学数学、计算机博士，深耕能源数字化领域 15 年，为全球第二大啤酒产线设计数字化系统。',
    linkedin: '#',
  },
  {
    name: '林雨桐',
    title: '联合创始人 & CTO',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20tech%20CTO%20portrait%20headshot%20wearing%20smart%20casual%20confident%20expression%20clean%20studio%20background%20corporate%20photography%20high%20quality&width=200&height=200&seq=team2&orientation=squarish',
    bio: '北京大学计算机硕士，前阿里云高级技术专家，主导过多个千万级用户平台架构设计。',
    linkedin: '#',
  },
  {
    name: '王志强',
    title: 'VP 产品',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20product%20VP%20portrait%20headshot%20wearing%20glasses%20blazer%20friendly%20smile%20clean%20studio%20background%20corporate%20photography%20high%20quality&width=200&height=200&seq=team3&orientation=squarish',
    bio: '前西门子工业软件产品总监，拥有 12 年 B2B SaaS 产品经验，服务过 100+ 制造业客户。',
    linkedin: '#',
  },
  {
    name: '张雪晴',
    title: 'VP 市场',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20marketing%20VP%20portrait%20headshot%20wearing%20elegant%20blouse%20warm%20smile%20clean%20studio%20background%20corporate%20photography%20high%20quality&width=200&height=200&seq=team4&orientation=squarish',
    bio: '前华为企业业务部市场总监，擅长 B2B 品牌建设和渠道拓展，推动企业数字化营销转型。',
    linkedin: '#',
  },
  {
    name: '刘浩然',
    title: '首席科学家',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20data%20scientist%20portrait%20headshot%20wearing%20turtleneck%20intellectual%20look%20clean%20studio%20background%20corporate%20photography%20high%20quality&width=200&height=200&seq=team5&orientation=squarish',
    bio: 'MIT 机器学习博士，发表顶会论文 30+ 篇，专注能源系统优化与碳排放预测模型研究。',
    linkedin: '#',
  },
  {
    name: '赵思琪',
    title: '客户成功总监',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20customer%20success%20director%20portrait%20headshot%20wearing%20business%20suit%20warm%20professional%20smile%20clean%20studio%20background%20corporate%20photography%20high%20quality&width=200&height=200&seq=team6&orientation=squarish',
    bio: '前 SAP 客户成功经理，服务过 50+ 世界 500 强企业，客户续约率保持 95% 以上。',
    linkedin: '#',
  },
];

export const coreValues = [
  {
    icon: 'ri-lightbulb-flash-line',
    title: '创新驱动',
    description: '以技术创新为核心驱动力，持续投入 AI 与大数据研发，引领能源管理行业变革。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '客户至上',
    description: '深入理解客户需求，提供定制化解决方案，确保每一位客户获得超预期价值。',
  },
  {
    icon: 'ri-earth-line',
    title: '绿色使命',
    description: '以技术赋能碳中和，帮助每一家企业降低碳足迹，共建可持续未来。',
  },
  {
    icon: 'ri-team-line',
    title: '开放协作',
    description: '与行业伙伴共建生态，开放 API 与数据接口，推动能源管理标准化。',
  },
];

export const partners = [
  { name: '国家电网', logo: 'ri-flashlight-line' },
  { name: '华为云', logo: 'ri-cloud-line' },
  { name: '阿里云', logo: 'ri-cloud-line' },
  { name: '清华大学', logo: 'ri-building-line' },
  { name: '北京大学', logo: 'ri-building-line' },
  { name: 'SGS', logo: 'ri-award-line' },
  { name: 'TUV', logo: 'ri-award-line' },
  { name: 'DNV', logo: 'ri-award-line' },
];